export const MEDIA_ASSETS_ROOT = "/assets/";